import dayjs from "dayjs";
import React from "react";
import { useNavigate } from "react-router-dom";

const ItemBody3 = ({ notification }) => {
  const navigate = useNavigate();

  return (
    <p className="font-poppins text-xs font-light">
      <span className="font-normal">Driver </span>
      <span
        className="font-medium text-primary underline cursor-pointer"
        onClick={() => navigate("/users?tab=drivers")}
      >
        {notification?.metaData?.firstName}{" "}
        {notification?.metaData?.lastName
          ? `${notification?.metaData?.lastName}'s`
          : ""}
      </span>
      ’s license is expiring on{" "}
      {dayjs(notification?.metaData?.licenseValidity).format("MMM DD, YYYY")}.
    </p>
  );
};

export default ItemBody3;
